export default {
    bg: require('../assets/images/food.chocolate.jpg'),
    sprites: [{
        image: require('../assets/images/food.elephant.png'),
        x: 50,
        y: 42,
        rot: 6,
        scale: 1,
    }, {
        image: require('../assets/images/food.deer.png'),
        x: 4,
        y: 42,
        rot: -4,
        scale: 1,
    }],
}